import { render, staticRenderFns } from "./FlavorGroups.vue?vue&type=template&id=e99e61ca&scoped=true&lang=pug&"
import script from "./FlavorGroups.vue?vue&type=script&lang=ts&"
export * from "./FlavorGroups.vue?vue&type=script&lang=ts&"
import style0 from "./FlavorGroups.vue?vue&type=style&index=0&id=e99e61ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99e61ca",
  null
  
)

export default component.exports